import * as React from 'react'

import { useFieldHover } from '../../hooks/useFieldHover'
import { cn } from '../../utils/cn'

type InputProps = Omit<React.ComponentProps<'input'>, 'size'> & {
  /** Height parity with Button: 'default' = 40px (medium), 'sm' = 32px, 'lg' = 50px. */
  size?: 'default' | 'sm' | 'lg'
}

function Input({ className, type, size = 'default', onPointerEnter, onPointerLeave, ...props }: InputProps) {
  const hoverProps = useFieldHover(onPointerEnter, onPointerLeave)

  return (
    <input
      type={type}
      data-slot="input"
      {...hoverProps}
      className={cn(
        'file:text-foreground placeholder:text-ink-300 selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input text-md bg-surface w-full min-w-0 rounded-md border px-4 transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:pointer-fine:text-sm',
        'enabled:hover:data-hovered:not-focus-visible:border-ink-300 focus-visible:border-ring',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        size === 'sm' ? 'h-8' : size === 'lg' ? 'h-[50px]' : 'h-10',
        className
      )}
      {...props}
    />
  )
}

export { Input }
